var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPasswordKey(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.7845 11.2303L20.1747 9.51226H10.7453C9.93915 8.00993 8.42616 6.99596 6.68916 7.00001C4.10133 6.9943 2.00583 9.23357 2 11.9919C2.00579 14.7567 4.1015 16.9958 6.68916 17C8.42133 16.997 9.931 15.9861 10.7385 14.4879H12.6352L14.1376 12.8993L15.287 14.1154L16.3904 12.9482L17.5242 14.1469L18.6736 12.9319L19.823 14.1469L21.7848 12.0729C22.0682 11.7605 22.0753 11.5412 21.7845 11.2303ZM4.63617 13.3052C3.94457 13.2985 3.38838 12.7032 3.39477 11.9755C3.38839 11.2379 3.94457 10.6431 4.63617 10.6465C5.31637 10.6427 5.87256 11.2379 5.87776 11.9755C5.87275 12.7032 5.31657 13.2982 4.63617 13.3052Z",
    fill: "#081E56"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPasswordKey);
export default __webpack_public_path__ + "static/media/PasswordKey.78be7fac6b9801e001e45403a686895f.svg";
export { ForwardRef as ReactComponent };